import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {SERVICE_CONFIG, TaskService} from '../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NzIconService} from 'ng-zorro-antd/icon';
import {Subscription} from 'rxjs';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
  providers: [DatePipe]
})
export class LayoutComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  isCollapsed = false;
  triggerTemplate: TemplateRef<void> | null = null;
  linkStatus = true;
  boardList: Array<any> = [];
  currentBoardId: string;
  currentBoardName = '';
  isVisible = false;
  boardName = '新面板';
  boardCategory;
  boardDateType: string;
  boardId: string;
  boardTypeValue = 'private';
  boardTypeDescription = '单独或选定的团队成员可见';
  isConfirmLoading = false;
  templateId = '';
  templateList: Array<any> = [];
  popVisible: boolean;
  isMemberVisible: boolean;
  flag = true;
  // excel导入相关 -- 开始
  excelImportVisible = false; // 是否展示excel导入弹窗
  excelModalWidth = 520; // 上传的excel文件
  excelData = []; // 解析excel得到的数据
  excelDisplayData = []; // excel展示的数据
  excelBoardName; // excel导入的面板名称
  excelSelectedData = []; // 最终选择的数据
  excelColumnTypes = []; // excel每列可选择的类型
  excelColumnPopVisible: Array<boolean> = [];
  excelTableColWidth = []; // excel表格每列宽度
  excelSelectedColWidth = []; // excel已选数据的每列宽度
  excelTableWidth = 60; // excel表格总宽度，初始值为60
  excelSelectedTableWidth = 60; // excel已选数据表格总宽度
  excelImportStep = -1; // 当前excel上传到第几步
  selectedRow = -1; // 当前选择的行
  selectedRowIndex = 0; // 当前选择的行的索引
  selectedColumn = -1; // 当前选择的列
  selectedColumnIndex = 0; // 当前选择的列的索引
  tableIndexX = -1;
  tableIndexY = -1;
  importButtonLoading = false;
  types = [];
  boardOperationPop = false;
  archiveBoardVisible = false;
  // excel导入相关 -- 结束
  boardNewName = '';
  boardTemplatePopVisible = false;
  renameVisible = false;
  attributeVisible = false;
  boardAttribute: any;
  @ViewChild('trigger', { static: true }) customTrigger: TemplateRef<void>;
  searchModalVisible = false;
  searchModalWidth = 0;
  searchModalHeight = '';
  searchModalTitle = '';
  searchModalContent = '';
  searchSpin = false;
  openSearch = false;
  dateFilterVisible = false;
  searchKey = '';
  searchDates = [];
  searchResult = [];
  selectedTag = 'crossBoards';
  archiveChecked = false;
  tableMaxHeight;
  boardCategoryVisible = false;
  editBoardCategoryVisible = false;
  boardCategoryName = '';
  boardCategoryId = '';
  boardCategoryList = [];
  boardViewType = 'maintable';
  selectBoardId: string;
  validateForm!: FormGroup;
  systemProfile: any;
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private nzIconService: NzIconService,
    private modalService: NzModalService,
    private datePipe: DatePipe,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.systemProfile = JSON.parse(localStorage.getItem('profile'));
    const height = document.getElementById('home-collapsible-item-component').clientHeight;
    this.tableMaxHeight = height - 150 + 'px';
    this.getBoardCategoryList();
    this.getBoardTemplateList();
    this.nzIconService.fetchFromIconfont({
      scriptUrl: 'assets/fonts/iconfont-1.js?v=0.2'
    });
    this.nzIconService.fetchFromIconfont({
      scriptUrl: 'assets/fonts/oc-font.js?v=0.11'
    });
    this.searchModalWidth = window.innerWidth * 0.9;
    this.searchModalHeight = window.innerHeight * 0.9 + 'px';
    this.searchModalTitle = window.innerHeight * 0.9 * 0.2 + 'px';
    this.searchModalContent = window.innerHeight * 0.9 * 0.8 + 'px';
    this.validateForm = this.fb.group({
      categoryId: [null],
      boardName: [null, [Validators.required]],
      boardDateType: [null, [Validators.required]],
      kind: [null, [Validators.required]],
      templateId: ['']
    });
  }
  ngOnDestroy() {
    this.clearLocalStorage();
  }
  // 任务面板/归档切换
  getChangeStatus(event) {
    if (event === 'archive') {
      this.linkStatus = false;
    } else {
      this.linkStatus = true;
    }
  }
  // 获取面板列表
  getBoardCategoryList() {
    this.taskService.getBoardCategoryList({}).subscribe((res: any) => {
      if (res) {
        this.boardCategoryList = res || [];
      }
      this.getBoardList();
    });
  }
  getBoardList() {
    this.dataSubscription = this.taskService.getUserBoardData().subscribe((res: any) => {
      if (res) {
        for (const item of this.boardCategoryList) {
          item.boardList = [];
        }
        const bId = localStorage.getItem('boardId');
        const bName = localStorage.getItem('boardName');
        this.boardList = res.boards;
        this.boardList.forEach((item, index) => {
          if (item.id === bId) {
            this.flag = false;
            this.currentBoardId = bId;
            this.currentBoardName = bName;
            this.boardAttribute = {
              boardDateType: item.boardDateType,
              boardId: this.currentBoardId,
              boardView: item.views
            };
          }
          if (!bId) {
            localStorage.setItem('defaultView', this.boardList[0].views);
            this.boardAttribute = {
              boardDateType: this.boardList[0].boardDateType,
              boardId: this.boardList[0].id,
              boardView: this.boardList[0].views
            };
          }
          if (item.categoryId && this.boardCategoryList && this.boardCategoryList.length > 0) {
            for (const category of this.boardCategoryList) {
              if (item.categoryId === category.id) {
                item.categoryActive = true;
                category.boardList.push(item);
                if (item.id === bId) {
                  category.active = true;
                  this.boardAttribute = {
                    boardDateType: item.boardDateType,
                    boardId: item.id,
                    boardView: item.views
                  };
                }
                break;
              }
            }
          }
        });
        this.boardList = this.boardList.filter(item => !item.categoryActive);
        if (this.flag) {
          if (this.boardList.length > 0) {
            this.currentBoardId = this.boardList[0].id;
            this.currentBoardName = this.boardList[0].name;
          } else {
            if (this.boardCategoryList && this.boardCategoryList.length > 0) {
              const first = this.boardCategoryList[0];
              if (first.boardList && first.boardList.length > 0) {
                this.currentBoardId = first.boardList[0].id;
                this.currentBoardName = first.boardList[0].name;
                first.active = true;
              }
            }
          }
        }
      }
    });
  }
  // 获取面板模板
  getBoardTemplateList() {
    this.dataSubscription = this.taskService.getBoardTemplateData().subscribe((res: any) => {
      if (res) {
        this.templateList = res;
      }
    });
  }
  // 切换面板事件
  selectBoardChange(item) {
    this.archiveBoardVisible = false;
    this.currentBoardId = item.id;
    this.currentBoardName = item.name;
    this.boardDateType = item.boardDateType;
    this.boardAttribute = {
      boardDateType: this.boardDateType,
      boardId: item.id,
      boardView: item.views
    };
    localStorage.setItem('boardId', item.id);
    localStorage.setItem('boardName', item.name);
    localStorage.setItem('defaultView', item.views);
  }

  showBoardGroupModal() {
    this.popVisible = false;
    this.boardCategoryVisible = true;
    this.boardCategoryName = null;
  }

  createBoardGroup() {
    if (!this.boardCategoryName) {
      this.message.info('请输入分组名称！');
      return;
    }
    this.taskService.createBoardCategory({name: this.boardCategoryName}).subscribe(res => {
      if (res) {
        this.boardCategoryList.push(res);
        this.boardCategoryVisible = false;
      } else {
        this.message.error('新增面板分组异常');
      }
    }, () => {
      this.boardCategoryVisible = false;
    });
  }
  editBoardGroup() {
    if (!this.boardCategoryName) {
      this.message.info('请输入分组名称！');
      return;
    }
    this.taskService.editBoardCategory({id: this.boardCategoryId, name: this.boardCategoryName}).subscribe(res => {
      if (res) {
        this.boardCategoryList.forEach(item => {
          if (item.id === this.boardCategoryId) {
            item.name = this.boardCategoryName;
          }
        });
      } else {
        this.message.error('编辑面板分组异常');
      }
      this.editBoardCategoryVisible = false;
    }, () => {
      this.editBoardCategoryVisible = false;
    });
  }
  // 新增面板
  createBlankBoard(item?: any) {
    this.isVisible = true;
    this.popVisible = false;
    this.boardCategory = null;
    this.validateForm.reset();
    if (item) {
      this.validateForm.get('boardName').patchValue(item.title);
      this.boardName = item.title;
      this.templateId = item.id;
    } else {
      this.boardName = '新面板';
      this.validateForm.get('boardName').patchValue(this.boardName);
    }
  }
  createCategoryBoard(item) {
    this.boardCategory = item.id;
    this.boardName = '新面板';
    this.validateForm.reset();
    this.validateForm.get('boardName').patchValue(this.boardName);
    this.validateForm.get('categoryId').patchValue(this.boardCategory);
    this.isVisible = true;
  }
  // 选择面板类型
  boardTypeChange() {
    switch (this.boardTypeValue) {
      case 'main':
        this.boardTypeDescription = '对您帐户中的所有人都可见';
        break;
      case 'private':
        this.boardTypeDescription = '单独或选定的团队成员可见';
        break;
      case 'shareable':
        this.boardTypeDescription = '与客户一起合作';
        break;
    }
  }
  // 弹出Excel导入弹窗
  showExcelImportModal() {
    this.popVisible = false;
    this.excelModalWidth = 520;
    this.excelImportVisible = true;
    this.excelImportStep = -1;
  }
  // excel文件上传处理
  handleFileUpload() {
    this.excelData = [];
    const fileInput = document.getElementById('excel-upload-input');
    fileInput.click();
    fileInput.onchange = () => {
      const files = fileInput['files'];
      const fileName = files[0].name as string;
      this.excelBoardName = fileName.substring(0, fileName.lastIndexOf('.'));
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array'});
        const sheetName: string = workbook.SheetNames[0];
        const ws = workbook.Sheets[sheetName];
        this.excelData = XLSX.utils.sheet_to_json(ws, {header: 1, blankrows: false, raw: false});
        // 如果没有数据或只有一行一列，错误提示
        if (!this.excelData || this.excelData.length === 0 ||
          (this.excelData.length === 1 && this.excelData[0].length === 1)) {
          this.excelImportStep = 4;
        } else {
          this.excelImportStep = 0;
          this.selectedRowIndex = 0;
          this.selectedColumnIndex = 0;
          this.excelTableWidth = 60;
          this.importButtonLoading = false;
          // 处理空数据
          let columnLength = 0;
          for (const row of this.excelData) {
            if (row.length > columnLength) {
              columnLength = row.length;
            }
          }
          for (const row of this.excelData) {
            const rowLength = columnLength - row.length;
            for (let i = 0; i < rowLength; i++) {
              row.push('');
            }
          }
          this.calculateColumnWidth();
          this.transferDataType();
        }
      };
      reader.readAsArrayBuffer(files[0]);
    };
  }
  uploadFileAgain() {
    this.excelImportStep = -1;
    setTimeout(() => {
      this.handleFileUpload();
    }, 50);
  }
  // 计算excel表格每列宽度
  calculateColumnWidth() {
    this.excelTableColWidth = [];
    if (this.excelData && this.excelData.length > 0) {
      const firstRow = this.excelData[0];
      for (let i = 0; i < firstRow.length; i++) {
        let maxWidth = 0;
        for (const row of this.excelData) {
          if (row[i] && row[i].length * 16 > maxWidth) {
            maxWidth = row[i].length * 16;
          }
        }
        this.excelTableWidth += (maxWidth + 8); // 加8是因为td的padding为0 4px
        this.excelTableColWidth.push(maxWidth + 8);
      }
    }
    if (this.excelTableWidth < 910) {
      for (let i = 0; i < this.excelTableColWidth.length; i++) {
        this.excelTableColWidth[i] = (this.excelTableColWidth[i] / (this.excelTableWidth - 60)) * 910;
      }
      this.excelTableWidth = 970;
    }
  }
  // 数据格式转换
  transferDataType() {
    this.excelDisplayData = [];
    for (const row of this.excelData) {
      const disRow = [];
      for (const cell of row) {
        disRow.push({
          value: cell, // 单元格的值
          rowHighlight: false, // 行高亮
          columnHighlight: false, // 列高亮
          cellHighlight: false // 单元格高亮
        });
      }
      this.excelDisplayData.push(disRow);
    }
  }
  // 个性化excel数据面板
  customExcelBoard() {
    this.excelImportStep = 1;
    this.excelModalWidth = 1000;
    this.selectedRowIndex = 0;
    this.selectedColumnIndex = 0;
    // 初始化时高亮第一行
    const row = this.excelDisplayData[this.selectedRowIndex];
    for (const cell of row) {
      cell.rowHighlight = true;
    }
  }

  // 回退
  stepBack() {
    this.excelImportStep--;
    if (this.excelImportStep === 0) { // 回退到文件上传完成面板
      this.excelModalWidth = 520;
      let row = this.excelDisplayData[this.selectedRowIndex];
      for (const cell of row) {
        cell.rowHighlight = false;
      }
    } else if (this.excelImportStep === 1) { // 回退到选择第一行面板
      for (const row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = false;
      }
      let row = this.excelDisplayData[this.selectedRowIndex];
      for (const cell of row) {
        cell.rowHighlight = true;
      }
    } else if (this.excelImportStep === 2) { // 回退到选择第一列面板
      this.columnHighlightCancel();
      this.rowHighlightCancel();
      this.highlightCellCancel();
      for (const row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = true;
      }
    }
  }

  nextStep() {
    this.excelImportStep++;
    if (this.excelImportStep === 2) { // 跳转到选择第一列
      let row = this.excelDisplayData[this.selectedRowIndex];
      for (const cell of row) {
        cell.rowHighlight = false;
      }
      // 高亮显示第一列
      this.selectedColumnIndex = 0;
      for (const row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = true;
      }
    } else if (this.excelImportStep === 3) { // 跳转到选择列类型
      this.selectedRow = -1;
      this.selectedColumn = -1;
      this.tableIndexX = -1;
      this.tableIndexY = -1;
      for (const row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = false;
      }
      this.calculateColumnType();
    }
  }

  getLetter(number): string {
    const letters = [
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
      'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
      'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
      'Y', 'Z'
    ];
    let title = '';
    let quotient;
    while (number >= 0) {
      quotient = number % 26;
      title += letters[quotient];
      if (number / 26 > 1) {
        number = quotient;
      } else {
        number = -1;
      }
    }
    return title;
  }

  getExplain(type): string {
    if (type === 'text') {
      return '文本';
    } else if (type === 'status') {
      return '状态';
    } else if (type === 'multiple-person') {
      return '人员';
    } else if (type === 'date') {
      return '日期';
    } else if (type === 'date-time') {
      return '日期时间';
    } else {
      return '未知类型';
    }
  }

  rowClick(i) {
    if (this.selectedRowIndex !== i) { // 新点击的行不是之前的那一行
      let row = this.excelDisplayData[this.selectedRowIndex];
      // 取消之前高亮显示的行
      for (const cell of row) {
        cell.rowHighlight = false;
      }
      // 高亮显示新行
      this.selectedRowIndex = i;
      row = this.excelDisplayData[i];
      for (const cell of row) {
        cell.rowHighlight = true;
      }
    }
  }

  columnClick(i) {
    // 不允许选择最后一列
    if (this.excelImportStep === 2 && i === (this.excelData[0].length - 1)) {
      this.message.warning('不能选择最后一列！');
      return;
    }
    if (this.selectedColumnIndex !== i) { // 新选择的列不是之前选择的那一列
      // 取消之前高亮显示的列
      for (let row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = false;
      }
      // 高亮显示新列
      this.selectedColumnIndex = i;
      for (let row of this.excelDisplayData) {
        row[this.selectedColumnIndex].columnHighlight = true;
      }
    }
  }
  // 高亮显示某一行
  highlightRow(i) {
    // 取消上次高亮显示的列
    this.columnHighlightCancel();
    // 取消上一次高亮显示的行
    this.rowHighlightCancel();
    // 取消上一次高亮显示的单元格
    this.highlightCellCancel();
    // 高亮显示新点击的行
    this.selectedRow = i;
    for (const cell of this.excelSelectedData[this.selectedRow]) {
      cell.rowHighlight = true;
    }
    this.selectedColumn = -1;
    this.tableIndexX = -1;
    this.tableIndexY = -1;
  }
  // 高亮显示某一列
  highlightColumn(i) {
    // 取消上次高亮显示的列
    this.columnHighlightCancel();
    // 取消上一次高亮显示的行
    this.rowHighlightCancel();
    // 取消上一次高亮显示的单元格
    this.highlightCellCancel();
    // 高亮显示新点击的列
    this.selectedColumn = i;
    for (const row of this.excelSelectedData) {
      row[this.selectedColumn].columnHighlight = true;
    }
    this.selectedRow = -1;
    this.tableIndexX = -1;
    this.tableIndexY = -1;
  }
  // 高亮显示单元格
  highlightCell(i, j) {
    this.columnHighlightCancel();
    this.rowHighlightCancel();
    this.highlightCellCancel();
    this.tableIndexX = i;
    this.tableIndexY = j;
    this.excelSelectedData[this.tableIndexX][this.tableIndexY].cellHighlight = true;
    this.selectedRow = -1;
    this.selectedColumn = -1;
  }
  // 取消单元格高亮显示
  highlightCellCancel() {
    if (this.tableIndexX !== -1 && this.tableIndexY !== -1) {
      this.excelSelectedData[this.tableIndexX][this.tableIndexY].cellHighlight = false;
    }
  }
  // 取消行高亮显示
  rowHighlightCancel() {
    if (this.selectedRow !== -1) {
      let row = this.excelSelectedData[this.selectedRow];
      for (const cell of row) {
        cell.rowHighlight = false;
      }
    }
  }
  // 取消列高亮显示
  columnHighlightCancel() {
    if (this.selectedColumn !== -1) {
      for (const row of this.excelSelectedData) {
        row[this.selectedColumn].columnHighlight = false;
      }
    }
  }

  // 计算excel每列数据可选择的类型
  calculateColumnType() {
    this.excelSelectedData = [];
    this.excelColumnTypes = [];
    this.types = [];
    for (let i = this.selectedRowIndex; i < this.excelDisplayData.length; i++) {
      const newRow = this.excelDisplayData[i].slice(this.selectedColumnIndex, this.excelDisplayData[i].length);
      this.excelSelectedData.push(newRow);
    }
    const columnCount = this.excelSelectedData[0].length;
    // 判断每列数据是否符合日期格式
    for (let i = 1; i < columnCount; i++) {
      const types = ['status', 'text', 'multiple-person'];
      let dateFlag = true;
      let statusFlag = true;
      for (let j = 1; j < this.excelSelectedData.length; j++) {
        const data = this.excelSelectedData[j][i];
        if (data.value && (!isNaN(data.value) || isNaN(Date.parse(data.value)))) {
          dateFlag = false;
          break;
        }
      }
      for (let j = 1; j < this.excelSelectedData.length; j++) {
        const data = this.excelSelectedData[j][i];
        if (data.value && data.value.length > 10) {
          statusFlag = false;
          break;
        }
      }
      if (dateFlag) {
        types.splice(0, 0, 'date', 'date-time');
      }
      if (!dateFlag && !statusFlag) {
        let temp = types[0];
        types[0] = types[1];
        types[1] = temp;
      }
      this.excelColumnTypes.push(types);
    }
    // 重新计算每列宽度
    this.excelSelectedTableWidth = 60;
    this.excelSelectedColWidth = this.excelTableColWidth.slice(this.selectedColumnIndex, this.excelTableColWidth.length);
    for (const col of this.excelSelectedColWidth) {
      this.excelSelectedTableWidth += col;
    }
    if (this.excelSelectedTableWidth < 910) {
      for (let i = 0; i < this.excelSelectedColWidth.length; i++) {
        this.excelSelectedColWidth[i] = (this.excelSelectedColWidth[i] / (this.excelSelectedTableWidth - 60)) * 910;
      }
      this.excelSelectedTableWidth = 970;
    }
    this.excelColumnPopVisible = [];
    // 初始化每列数据类型
    for (const colTypes of this.excelColumnTypes) {
      this.types.push(colTypes[0]);
      this.excelColumnPopVisible.push(false);
    }
  }

  // 更改列的数据类型
  changeColumnType(i, type) {
    this.types[i] = type;
    this.excelColumnPopVisible[i] = false;
  }

  translateMail(value) {
    if (value) {
      const reg = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
      const mails = value.split(/[,，]/g);
      let flag = true;
      for (const mail of mails) {
        flag = flag || reg.test(mail);
      }
      return flag ? value: '';
    } else {
      return '';
    }
  }

  // 从Excel导入数据到面板
  importFromExcel() {
    this.importButtonLoading = true;
    let excelSelectedData = [];
    for (let i = this.selectedRowIndex; i < this.excelData.length; i++) {
      const newRow = this.excelData[i].slice(this.selectedColumnIndex, this.excelData[i].length);
      excelSelectedData.push(newRow);
    }
    // 处理日期和日期时间类型的数据, i为行 j为列
    if (excelSelectedData.length > 1) {
      for (let j = 0; j < this.types.length; j++) {
        if (this.types[j] === 'date') {
          for (let i = 1; i < excelSelectedData.length; i++) {
            if (excelSelectedData[i][j + 1]) {
              excelSelectedData[i][j + 1] = this.datePipe.transform(new Date(excelSelectedData[i][j + 1]), 'yyyy-MM-dd');
            }
          }
        } else if (this.types[j] === 'date-time') {
          for (let i = 1; i < excelSelectedData.length; i++) {
            if (excelSelectedData[i][j + 1]) {
              excelSelectedData[i][j + 1] = this.datePipe.transform(new Date(excelSelectedData[i][j + 1]), 'yyyy-MM-dd HH:mm:ss');
            }
          }
        } else if (this.types[j] === 'multiple-person') {
          for (let i = 1; i < excelSelectedData.length; i++) {
            if (excelSelectedData[i][j + 1]) {
              excelSelectedData[i][j + 1] = this.translateMail(excelSelectedData[i][j + 1]);
            }
          }
        }
      }
    }
    const param = {
      matrix: excelSelectedData.length > 1 ?
        JSON.stringify(excelSelectedData.slice(1, excelSelectedData.length)) : [],
      names: excelSelectedData[0],
      types: this.types,
      boardName: this.excelBoardName,
      boardKind: 'main'
    };
    this.taskService.importExcelToBoard(param).subscribe(result => {
      if (result && result['boardId']) {
        localStorage.setItem('boardId', result['boardId']);
        this.message.success('导入成功!');
        this.getBoardList();
        this.excelImportVisible = false;
      } else {
        this.message.error('导入失败!');
      }
      this.importButtonLoading = false;
    });
  }
  // 关闭弹窗
  handleCancel() {
    this.isVisible = false;
  }
  // 确定提交
  submitForm() {
    if (this.validateForm.valid) {
      this.isConfirmLoading = true;
      const param = this.validateForm.getRawValue();
      this.dataSubscription = this.taskService.doCreateBoard(param).subscribe((res: any) => {
        if (res) {
          this.boardId = res.id;
        }
        this.isVisible = false;
        this.isConfirmLoading = false;
        this.message.create('success', '创建成功！');
        this.boardAttribute = {
          boardDateType: this.validateForm.get('boardDateType').value,
          boardId: this.currentBoardId
        };
        this.getBoardList();
        if (this.boardTypeValue === 'private') {
          this.modalService.confirm({
            nzTitle: '<i>是否继续添加面板成员？</i>',
            nzWrapClassName: 'vertical-center-modal',
            nzOkText: '继续',
            nzOnOk: () => {
              this.isMemberVisible = true;
            },
            nzCancelText: '稍后',
            nzOnCancel: () => {
              this.isVisible = false;
            }
          });
        }
      }, (err) => {
        this.isConfirmLoading = false;
      });
    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  handleOk() {
    this.submitForm();
  }

  // 展示重命名弹窗
  showBoardRenameModal(item) {
    this.renameVisible = true;
    item['templatePopVisible'] = false;
    this.boardNewName = item.name;
    this.selectBoardId = item.id;
  }
  // 编辑面板属性
  showBoardAttributeModal(item) {
    this.attributeVisible = true;
    item['templatePopVisible'] = false;
    this.boardNewName = item.name;
    this.selectBoardId = item.id;
    this.boardDateType = item.boardDateType;
  }

  // 面板重命名
  renameBoard() {
    if (!this.boardNewName) {
      this.message.warning('请输入面板名称！');
      return;
    }
    this.dataSubscription = this.taskService.updateBoard(this.selectBoardId, {boardName: this.boardNewName}).subscribe(res => {
      if (res) {
        this.message.success('修改成功！');
        for (const board of this.boardList) {
          if (board.id === this.selectBoardId) {
            board.name = this.boardNewName;
            break;
          }
        }
        this.boardCategoryList.forEach(cate => {
          cate.boardList.forEach(board => {
            if (board.id === this.selectBoardId) {
              board.name = this.boardNewName;
            }
          });
        });
        this.renameVisible = false;
      } else {
        this.message.error('修改面板名称失败！');
      }
    });
  }
  // 编辑面板属性
  editAttributeBoard() {
    this.dataSubscription = this.taskService.updateBoard(this.selectBoardId, {boardDateType: this.boardDateType}).subscribe(res => {
      if (res) {
        this.message.success('修改成功！');
        this.boardAttribute = {
          boardDateType: this.boardDateType,
          boardId: this.currentBoardId
        };
        for (const board of this.boardList) {
          if (board.id === this.selectBoardId) {
            board.boardDateType = this.boardDateType;
            break;
          }
        }
        this.attributeVisible = false;
        this.getBoardCategoryList();
      } else {
        this.message.error('修改面板属性失败！');
      }
    });
  }
  // 归档面板
  archiveBoard(item) {
    this.dataSubscription = this.taskService.doDeleteBoard(item.id, {}).subscribe((res: any) => {
      this.message.create('success', '归档成功！');
      this.refreshBoard();
    });
  }
  refreshBoard() {
    this.getBoardList();
    this.currentBoardId = '';
    this.currentBoardName = '';
    this.clearLocalStorage();
  }
  // 删除面板
  removeBoard(item) {
    this.dataSubscription = this.taskService.doDeleteBoard(item.id, {'destroy': true}).subscribe((res: any) => {
      this.message.create('success', '删除成功！');
      this.refreshBoard();
    });
  }
  changeBoardCategory(board) {
    this.taskService.updateBoard(board.id, {categoryId: board.categoryId}).subscribe(res => {
      if (res) {
        this.boardList = this.boardList.filter(item => item.id !== board.id);
        for (const item of this.boardCategoryList) {
          if (item.boardList) {
            item.boardList = item.boardList.filter(i => i.id !== board.id);
            if (item.id === board.categoryId) {
              item.boardList.push(board);
              item.active = true;
            }
          }
        }
      } else {
        this.message.error('移动分组失败！');
      }
      board.templatePopVisible = false;
    });
  }
  changeBoardKind(item, kind) {
    this.taskService.updateBoard(item.id, {kind: kind}).subscribe(res =>{
      if (res) {
        item.kind = kind;
      } else {
        this.message.error('修改失败');
      }
      item['templatePopVisible'] = false;
    });
  }
  // 清除本地存储
  clearLocalStorage() {
    if (localStorage.getItem('boardId')) {
      localStorage.removeItem('boardId');
    }
    if (localStorage.getItem('boardName')) {
      localStorage.removeItem('boardName');
    }
  }
  // 私有面板选择成员
  handleSelectMember() {
    this.isMemberVisible = true;
  }
  handleMemberOk() {
    this.isMemberVisible = true;
  }
  // 选择成员弹窗事件
  handleMemberCancel() {
    this.isMemberVisible = false;
  }

  // 路由到归档页面
  routToArchive() {
    this.boardOperationPop = false;
    this.archiveBoardVisible = true;
  }

  showSearchModal() {
    this.searchModalVisible = true;
    this.boardOperationPop = false;
  }

  showDateFilter() {
    this.dateFilterVisible = !this.dateFilterVisible;
    if (this.dateFilterVisible) {
      this.searchModalContent = window.innerHeight * 0.9 * 0.8 - 80 + 'px';
    } else {
      this.searchModalContent = window.innerHeight * 0.9 * 0.8 + 'px';
      this.searchDates = [];
    }
  }

  refreshBoardList() {

    this.taskService.getBoardCategoryList({}).subscribe((res: any) => {
      if (res) {
        this.boardCategoryList = res || [];
      }
      this.getBoardList();
    });
    // this.dataSubscription = this.taskService.getUserBoardData().subscribe((res: any) => {
    //   if (res) {
    //     this.boardList = res.boards;
    //   }
    // });
  }

  changeTag(tag) {
    this.selectedTag = tag;
    this.search();
  }

  getSearchDates(val) {
    this.searchDates = val || [];
  }

  search() {
    this.openSearch = true;
    if (this.searchKey || this.searchDates.length > 0) {
      this.searchSpin = true;
      const param = {
        keyword: this.searchKey,
        dates: this.searchDates,
        mode: this.selectedTag || 'crossBoards',
        archive: this.archiveChecked
      };
      this.searchResult = [];
      this.taskService.searchEverything(param).subscribe(res => {
        this.searchSpin = false;
        let result = res as Array<any>;
        if (res) {
          for (let board of result) {
            let boardData = board['boardData'];
            if (boardData.pulses && boardData.pulses.length > 0) {
              let groupIds = [];
              for (let pulse of boardData.pulses) {
                groupIds.push(pulse.groupId);
              }
              boardData.groups = boardData.groups.filter(item => groupIds.includes(item.id));
              this.searchResult.push(board);
            }
          }
        }
      });
    }
  }
  // 编辑/删除分类
  editCategory(item) {
    this.boardCategoryName = item.name;
    this.boardCategoryId = item.id;
    this.editBoardCategoryVisible = true;
  }
  removeCategory(item) {
    this.boardCategoryName = item.name;
    this.boardCategoryId = item.id;
    this.taskService.removeBoardCategory(this.boardCategoryId).subscribe(res => {
      this.taskService.getBoardCategoryList({}).subscribe((res: any) => {
        if (res) {
          this.boardCategoryList = res || [];
        }
        this.getBoardList();
      });
      this.message.create('success', '删除成功！');
    });
  }
}
